import CategoryViewRow from './CategoryViewRow';

export default CategoryViewRow;
